import * as React from "react";

import Field from "components/FormElements/Field";
import SelectInput from "components/FormElements/SelectInput";

import {
  FIELD_PROP_NAMES,
  FieldPropsType,
  SelectInputPropsType,
} from "components/FormElements/types";

import { take } from "utils";

const INPUT_PROP_NAMES = [
  "id",
  "name",
  "onBlur",
  "onChange",
  "options",
  "placeholder",
  "value",
];

interface PropsType
  extends Omit<FieldPropsType, "children">,
    SelectInputPropsType {}

function SelectField(props: PropsType): JSX.Element {
  const fieldProps = take(props, FIELD_PROP_NAMES);
  const inputProps = take(props, INPUT_PROP_NAMES);

  return (
    <Field className="select" {...fieldProps}>
      <SelectInput {...inputProps} />
    </Field>
  );
}

export { PropsType, SelectField as default };
